function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Mime_extensionToType, _Mime_typeToExtension, _Mime_typeToExtensions;
var Mime = /*#__PURE__*/function () {
  function Mime() {
    _classCallCheck(this, Mime);
    _Mime_extensionToType.set(this, new Map());
    _Mime_typeToExtension.set(this, new Map());
    _Mime_typeToExtensions.set(this, new Map());
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    for (var _i = 0, _args = args; _i < _args.length; _i++) {
      var arg = _args[_i];
      this.define(arg);
    }
  }
  return _createClass(Mime, [{
    key: "define",
    value: function define(typeMap) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      for (var _i2 = 0, _Object$entries = Object.entries(typeMap); _i2 < _Object$entries.length; _i2++) {
        var _ref = _Object$entries[_i2];
        var _ref2 = _slicedToArray(_ref, 2);
        var type = _ref2[0];
        var extensions = _ref2[1];
        type = type.toLowerCase();
        extensions = extensions.map(function (ext) {
          return ext.toLowerCase();
        });
        if (!__classPrivateFieldGet(this, _Mime_typeToExtensions, "f").has(type)) {
          __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").set(type, new Set());
        }
        var allExtensions = __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").get(type);
        var first = true;
        var _iterator = _createForOfIteratorHelper(extensions),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var extension = _step.value;
            var starred = extension.startsWith('*');
            extension = starred ? extension.slice(1) : extension;
            allExtensions === null || allExtensions === void 0 || allExtensions.add(extension);
            if (first) {
              __classPrivateFieldGet(this, _Mime_typeToExtension, "f").set(type, extension);
            }
            first = false;
            if (starred) continue;
            var currentType = __classPrivateFieldGet(this, _Mime_extensionToType, "f").get(extension);
            if (currentType && currentType != type && !force) {
              throw new Error("\"".concat(type, " -> ").concat(extension, "\" conflicts with \"").concat(currentType, " -> ").concat(extension, "\". Pass `force=true` to override this definition."));
            }
            __classPrivateFieldGet(this, _Mime_extensionToType, "f").set(extension, type);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return this;
    }
  }, {
    key: "getType",
    value: function getType(path) {
      var _classPrivateFieldGe;
      if (typeof path !== 'string') return null;
      var last = path.replace(/^.*[/\\]/, '').toLowerCase();
      var ext = last.replace(/^.*\./, '').toLowerCase();
      var hasPath = last.length < path.length;
      var hasDot = ext.length < last.length - 1;
      if (!hasDot && hasPath) return null;
      return (_classPrivateFieldGe = __classPrivateFieldGet(this, _Mime_extensionToType, "f").get(ext)) !== null && _classPrivateFieldGe !== void 0 ? _classPrivateFieldGe : null;
    }
  }, {
    key: "getExtension",
    value: function getExtension(type) {
      var _type, _type$split, _ref3;
      if (typeof type !== 'string') return null;
      type = (_type = type) === null || _type === void 0 || (_type$split = _type.split) === null || _type$split === void 0 ? void 0 : _type$split.call(_type, ';')[0];
      return (_ref3 = type && __classPrivateFieldGet(this, _Mime_typeToExtension, "f").get(type.trim().toLowerCase())) !== null && _ref3 !== void 0 ? _ref3 : null;
    }
  }, {
    key: "getAllExtensions",
    value: function getAllExtensions(type) {
      var _classPrivateFieldGe2;
      if (typeof type !== 'string') return null;
      return (_classPrivateFieldGe2 = __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").get(type.toLowerCase())) !== null && _classPrivateFieldGe2 !== void 0 ? _classPrivateFieldGe2 : null;
    }
  }, {
    key: "_freeze",
    value: function _freeze() {
      this.define = function () {
        throw new Error('define() not allowed for built-in Mime objects. See https://github.com/broofa/mime/blob/main/README.md#custom-mime-instances');
      };
      Object.freeze(this);
      var _iterator2 = _createForOfIteratorHelper(__classPrivateFieldGet(this, _Mime_typeToExtensions, "f").values()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var extensions = _step2.value;
          Object.freeze(extensions);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return this;
    }
  }, {
    key: "_getTestState",
    value: function _getTestState() {
      return {
        types: __classPrivateFieldGet(this, _Mime_extensionToType, "f"),
        extensions: __classPrivateFieldGet(this, _Mime_typeToExtension, "f")
      };
    }
  }]);
}();
_Mime_extensionToType = new WeakMap(), _Mime_typeToExtension = new WeakMap(), _Mime_typeToExtensions = new WeakMap();
export default Mime;